<template>
    <v-modal-slot id="delete-expedient-modal"
                  ref="delete-expedient-modal"
                  size="lg"
                  :do-close-on-accept="false"
                  @accepted="deleteClient">
        <template v-slot:modal-title>
            Borrar expediente
        </template>

        <template v-slot:modal-content>
            Vas a borrar el expediente <span class="badge bg-primary">{{ expedient.name }}</span> de tipo de contrato <span class="badge bg-secondary">{{ expedient.contract_type_display }}</span> para el cliente <span class="badge bg-dark">({{ expedient.clients[0].code }}) {{ expedient.clients[0].fullName }}</span> y la entidad <span class="badge bg-dark">{{ expedient.entities[0].name }}</span>. Este cambio no se puede deshacer. ¿Estás seguro?
        </template>

        <template v-slot:accept-button>
            Borrar
        </template>

        <template v-slot:close-button>
            Cancelar
        </template>
    </v-modal-slot>
</template>

<script>
import {deleteExpedient} from "../../../helpers/requests/RequestsExpedients";
import VModal from "../../general/VModal";
import VModalSlot from "../../general/VModalSlot";

export default {
    name: "ExpedientsListDeleteModal",
    components: {VModalSlot, VModal},
    props: {
        expedient: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        async deleteClient() {
            // Remember this: event 'accepted' or 'closed' fired in VModal, is propagated so:
            //      It is fired in VModal.vue, and caught here by the @accepted in v-modal-slot, but we are not firing it
            //      again and it is being captured in ExpedientsList.vue because of propagation. The thing is here we
            //      catch that @accept to delete it, but we do not emit it again. It is propagated by itself so in
            //      ExpedientsList.vue we are making the app reload Expedients and hide the modal (modalToShow = null).
            //
            //      The same happens with 'closed'. We are even not capturing it here, but it is propagated so we catch
            //      it in ExpedientsList.vue to hide the modal (modalToShow = null).
            //
            //      Custom events can not be stopped, native yes, so it will navigate from the child to all his parents that are
            //      listening.
            try {
                await deleteExpedient(this.expedient.id);

                this.$store.dispatch('app/setToastMessage', 'Expediente eliminado');
                this.$emit('accepted');
            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al eliminar el expediente');
            }
        },
    }
}
</script>
